import React, { useState, useCallback } from 'react'
import Dropdown from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import styles from './styles.less'
import PresenceButtonLabel from './Label'
import PresenceDropdown from '../Dropdown'
import PresenceSettingsSidebar from '../SettingsSidebar'

export default function PresenceButton({
  onSettingChange,
  onPresenceChange,
  autoAwaySetting,
  autoOfflineSetting,
  autoPresenceSetting,
  presence,
}) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const handleOnClose = useCallback(
    () => {
      setIsSidebarOpen(false)
    },
    [setIsSidebarOpen]
  )

  const handleOnSettingChange = useCallback(
    settings => {
      setIsSidebarOpen(false)
      if (onSettingChange) onSettingChange(settings)
    },
    [setIsSidebarOpen, onSettingChange]
  )

  return (
    <>
      <Dropdown
        position="top-start"
        strategy="fixed"
        autoHeight
        overlay={
          <PresenceDropdown
            onPresenceChange={onPresenceChange}
            autoPresenceSetting={autoPresenceSetting}
            presence={presence}
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
          />
        }
      >
        <Button type="tertiary" size="small" className={styles.button}>
          Profile status: <PresenceButtonLabel presence={presence} />
        </Button>
      </Dropdown>
      <PresenceSettingsSidebar
        open={isSidebarOpen}
        onClose={handleOnClose}
        onSave={handleOnSettingChange}
        autoAwaySetting={autoAwaySetting}
        autoOfflineSetting={autoOfflineSetting}
      />
    </>
  )
}
